// src/portals/fan/FanLayout.js
import React from "react";
import { Outlet } from "react-router-dom";

const FanLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow pb-16 md:pb-0">
        <Outlet />
      </div>
    </div>
  );
};

export default FanLayout;
